import React, { useEffect, useState } from "react";
import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
} from "@mui/material";
import { authFetch } from "../../services/apiClient";
import { formatDateTimeEs, formatScoreOverHundred } from "../../utils/formatters";

export const FichajePreviewDialog = ({ preview, onClose }) => {
	const [previewSrc, setPreviewSrc] = useState("");
	const [previewLoading, setPreviewLoading] = useState(false);
	const [previewError, setPreviewError] = useState("");

	useEffect(() => {
		let active = true;
		let objectUrl = null;

		const cargarImagenFichaje = async () => {
			if (!preview?.endpoint) {
				setPreviewSrc("");
				setPreviewLoading(false);
				setPreviewError("");
				return;
			}

			setPreviewLoading(true);
			setPreviewError("");
			setPreviewSrc("");

			try {
				const separator = preview.endpoint.includes("?") ? "&" : "?";
				const endpoint = `${preview.endpoint}${separator}t=${Date.now()}`;
				const res = await authFetch(endpoint, {
					headers: {
						"Cache-Control": "no-cache",
						Pragma: "no-cache",
					},
				});

				if (!res.ok) {
					throw new Error("No se pudo cargar la imagen del fichaje");
				}

				const blob = await res.blob();
				objectUrl = URL.createObjectURL(blob);

				if (active) {
					setPreviewSrc(objectUrl);
				}
			} catch (error) {
				console.error("Error cargando imagen del fichaje:", error);
				if (active) {
					setPreviewSrc("");
					setPreviewError("No se pudo cargar la imagen del fichaje");
				}
			} finally {
				if (active) {
					setPreviewLoading(false);
				}
			}
		};

		void cargarImagenFichaje();

		return () => {
			active = false;
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [preview?.endpoint]);

	return (
		<Dialog open={Boolean(preview)} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>Foto del fichaje</DialogTitle>
			<DialogContent sx={{ display: "flex", justifyContent: "center", p: 2 }}>
				{preview && (
					<Grid container direction="column" spacing={2}>
						<Grid item size={{ xs: 12 }}>
							<Typography variant="subtitle1">
								{preview.personaNombre} · {formatDateTimeEs(preview.fecha)}
							</Typography>
							{preview?.puntuacion !== undefined && preview?.puntuacion !== null && (
								<Typography variant="body2" color="text.secondary">
									Puntuacion: {formatScoreOverHundred(preview.puntuacion)}
								</Typography>
							)}
						</Grid>

						<Grid item size={{ xs: 12 }}>
							{previewLoading ? (
								<Box
									sx={{
										minHeight: "35vh",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<CircularProgress />
								</Box>
							) : previewError ? (
								<Alert severity="error">{previewError}</Alert>
							) : (
								<Box
									component="img"
									src={previewSrc}
									alt={`Fichaje de ${preview.personaNombre}`}
									sx={{
										maxWidth: "100%",
										maxHeight: "70vh",
										objectFit: "contain",
										borderRadius: 1,
									}}
								/>
							)}
						</Grid>
					</Grid>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cerrar</Button>
			</DialogActions>
		</Dialog>
	);
};
